import Context from './context';


class Channel {

  static getChannelByPath(channel, path) {
    const steps = path.split('/');
    let start = channel;

    if(path.charAt(0) === '/') {
      while(start.parent) {
        start = channel.parent;
      }
    }

    return steps.reduce((accumulator, current, index, array) => {

      if(current === '' || current === '.') {
        return accumulator;
      }
      else if(current === '..') {
        return accumulator.parent ? accumulator.parent : accumulator;
      }
      else {
        return accumulator.channels[current] ? accumulator.channels[current] : nullChannel;
      }

    }, start);

  }

  constructor(context) {
    this.context = context;
    this.parent = null;
    this._channels = {};
  }

  get name() {
    return this.context.name;
  }

  get channels() {
    return this._channels;
  }

  get root() {
    let current = this;

    while(current.parent) {
      current = current.parent;
    }

    return current;
  }

  sendDownstream(action, payload = {}, done) {

    this.context.executeAction(action, payload, () => {
      for(let key in this._channels) {
        this._channels[key].sendDownstream(action, payload, done);
      }
    });
  }

  sendUpstream(action, payload = {}, done) {

    this.context.executeAction(action, payload, () => {

      if(!this.parent) {
        return;
      }

      this.parent.sendUpstream(action, payload, done);
    });
  }

  send(action, payload = {}, done) {
    this.context.executeAction(action, payload, done);
  }

  connect(channel) {

    if(this._channels[channel.name]) {
      throw new Error('channel.name must be unique in its siblings');
    }

    channel.parent = this;

    this._channels[channel.name] = channel;
  }

  disconnect(channel) {

    if(!this._channels[channel.name] || channel.parent !== this) {
      return;
    }

    channel.parent = null;

    delete this._channels[channel.name];
  }

  disconnectFromParent() {

    if(!this.parent) {
      return;
    }

    this.parent.disconnect(this);
  }

  isAllocated(name) {
    return this.name === name;
  }

}

const nullContext = new Context();
const nullChannel = new Channel(nullContext);


export default Channel;



// WEBPACK FOOTER //
// ./src/js/app/channel.js